import { Button } from '@vrplatform/components';
import { showErrorNotification } from '@vrplatform/theme';
import { Box, Input, PinInput, Stack, rem } from '@mantine/core';
import { useState } from 'react';

type Props = {
  handleResendConfirmation: () => Promise<void>;
  handleCodeConfirmation: (code: string) => Promise<void>;
  loadingResend: boolean;
};

export const SignUpConfirmationView = ({
  handleResendConfirmation,
  loadingResend,
  handleCodeConfirmation,
}: Props) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleConfirmation = async (c: string) => {
    const code = c?.trim();
    if (!code)
      return showErrorNotification({
        color: 'yellow',
        title: 'Invalid code',
        message: 'Please enter a confirmation code.',
      });

    setLoading(true);
    try {
      await handleCodeConfirmation(code);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  return (
    <Box maw={'470px'}>
      <Stack mt={rem(60)} mb={rem(80)}>
        <Input.Label>Confirmation Code:</Input.Label>
        <PinInput
          value={code}
          onChange={setCode}
          length={6}
          size="xl"
          data-testid="confirmation-code"
        />
      </Stack>

      <Stack>
        <Button
          loading={loading}
          onClick={() => handleConfirmation(code)}
          variant="primary"
          type="submit"
          data-testid="verify-code"
          sx={(theme) => ({
            marginBottom: theme.spacing.sm,
          })}
        >
          Verify code
        </Button>
        <Button
          loading={loadingResend}
          onClick={handleResendConfirmation}
          leftIcon={'RefreshCwIcon'}
        >
          Resend confirmation code
        </Button>
      </Stack>
    </Box>
  );
};
